import React from "react";

import { CenteredForm } from "@common/components/CenteredForm/CenteredForm";
import AuthorizeElement from "@main/pages/Authorize/components/AuthorizeElement/AuthorizeElement";

export default function AuthorizeView() {
  return (
    <CenteredForm>
      <AuthorizeElement />
    </CenteredForm>
  );
}
